import React, { useState, useEffect } from 'react';
import { BlockPicker } from 'react-color';
import { useShophireReducer, actions } from './ShophireProvider';
import { v4 as uuidv4 } from 'uuid';

const SuggestedColors = ['#000', '#808080', '#ff0000', '#0000ff', '#008000'];

const useOutsideAlerter = (callback) => {
  useEffect(() => {
    function handleClickOutside(event) {
      if (event.target.className.indexOf('color-picker') === -1 && !event.target.title && !!event.target.spellcheck) {
        callback();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
};

const ColorPicker = ({ defaultColor, onSelectColor, colorName, uid }) => {
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const { dispatch, state: shophireState } = useShophireReducer();
  const { colorPicker: currentPicker = '' } = { ...shophireState };

  const closePicker = () => {
    setIsPickerOpen(false);
    dispatch({
      type: actions.SET_COLOR_PICKER,
      payload: uid,
    });
  };

  useOutsideAlerter(closePicker);

  const togglePicker = () => {
    setIsPickerOpen(!isPickerOpen);
    dispatch({
      type: actions.SET_COLOR_PICKER,
      payload: uid,
    });
  };

  const onSetColor = (color, event) => {
    event.persist();
    const updatedColor = {
      hue: color?.hsl?.h,
      saturation: color?.hsl?.s,
      brightness: color?.hsl?.l,
      alpha: color?.hsl?.a,
    };
    onSelectColor(updatedColor);
    closePicker();
  };

  const background = `hsl(${defaultColor?.hue}, ${defaultColor?.saturation * 100}%, ${defaultColor?.brightness * 100}%)`;

  const formattedColor = {
    h: defaultColor?.hue,
    s: defaultColor?.saturation,
    l: defaultColor?.brightness,
    a: defaultColor?.alpha || 1,
  };

  return (
    <div className='color-picker__row'>
      <span>{colorName}: </span>
      <div className='color-picker'>
        <span className='color-picker__selected' style={{ background }} onClick={togglePicker} />
        {isPickerOpen && currentPicker === uid && (
          <div className='color-picker__container'>
            <BlockPicker
              width='100%'
              height='190px'
              onChangeComplete={onSetColor}
              colors={SuggestedColors}
              color={formattedColor}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default (props) => {
  return <ColorPicker {...props} uid={uuidv4()} />;
};
